<template>
  <el-dialog
    :visible.sync="visible"
    title="发票详情"
    width="80%"
    @close="handleClose"
    v-loading="loading"
  >
    <el-button type="primary" @click="fetchInvoiceData(invoiceId)">刷新</el-button>
    <br/>
    <div class="invoice-detail">
      <h3>发票信息</h3>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="发票号">{{ invoice.invoiceNo }}</el-descriptions-item>
        <el-descriptions-item label="发票类型">
          <span v-if="invoice.invoiceKindCode == 82">普票</span>
          <span v-else>专票</span>
        </el-descriptions-item>
        <el-descriptions-item label="发票日期">{{ invoice.invoiceDate }}</el-descriptions-item>
        <el-descriptions-item label="税额">{{ invoice.taxAmount }}</el-descriptions-item>
        <el-descriptions-item label="总额">{{ invoice.totalAmount }}</el-descriptions-item>
        <el-descriptions-item label="购方税号">{{ invoice.buyerTaxCode }}</el-descriptions-item>
        <el-descriptions-item label="购方名称">{{ invoice.buyerName }}</el-descriptions-item>
        <el-descriptions-item label="购方地址">{{ invoice.buyerBusinessAddress }}</el-descriptions-item>
        <el-descriptions-item label="发票备注">{{ invoice.invoiceRemark }}</el-descriptions-item>
        <el-descriptions-item label="EWM地址">
          <a :href="invoice.ewmUrl" target="_blank">{{ invoice.ewmUrl }}</a>
        </el-descriptions-item>
        <el-descriptions-item label="PDF地址">
          <a :href="invoice.pdfUrl" target="_blank">{{ invoice.pdfUrl }}</a>
        </el-descriptions-item>
        <el-descriptions-item label="OFD地址">
          <a :href="invoice.ofdUrl" target="_blank">{{ invoice.ofdUrl }}</a>
        </el-descriptions-item>
        <el-descriptions-item label="XML地址">
          <a :href="invoice.xmlUrl" target="_blank">{{ invoice.xmlUrl }}</a>
        </el-descriptions-item>
      </el-descriptions>

      <h3 v-if="invoice.is_cancel > 0">红冲发票信息</h3>
      <el-descriptions :column="3" border v-if="invoice.is_cancel > 0">
        <el-descriptions-item label="红冲发票号">
          <el-button v-if="invoice.red.invoiceNo === ''" @click="applyIssue">红冲确认</el-button>
          <span v-else>{{ invoice.red.invoiceNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="红冲确认单状态">
          <span v-if="invoice.red.confirmStatus === '01'">无需确认</span>
          <span v-if="invoice.red.confirmStatus === '02'">销方录入待购方确认</span>
          <span v-if="invoice.red.confirmStatus === '03'">购方录入待销方确认</span>
          <span v-if="invoice.red.confirmStatus === '04'">购销双方已确认</span>
          <span v-if="invoice.red.confirmStatus === '05'">作废（销方录入购方否认）</span>
          <span v-if="invoice.red.confirmStatus === '06'">作废（购方录入销方否认）</span>
          <span v-if="invoice.red.confirmStatus === '07'">作废（超72小时未确认）</span>
          <span v-if="invoice.red.confirmStatus === '08'">发起方撤销</span>
          <span v-if="invoice.red.confirmStatus === '09'">作废（确认后撤销）</span>
          <span v-if="invoice.red.confirmStatus === '10'">作废（异常凭证）</span>
        </el-descriptions-item>
        <el-descriptions-item label="红冲发票日期">{{ invoice.red.invoiceDate }}</el-descriptions-item>
        <el-descriptions-item label="税额">{{ invoice.red.taxAmount }}</el-descriptions-item>
        <el-descriptions-item label="总额">{{ invoice.red.totalAmount }}</el-descriptions-item>
        <el-descriptions-item label="EWM地址">
          <a :href="invoice.red.ewmUrl" target="_blank">{{ invoice.red.ewmUrl }}</a>
        </el-descriptions-item>
        <el-descriptions-item label="PDF地址">
          <a :href="invoice.red.pdfUrl" target="_blank">{{ invoice.red.pdfUrl }}</a>
        </el-descriptions-item>
        <el-descriptions-item label="OFD地址">
          <a :href="invoice.red.ofdUrl" target="_blank">{{ invoice.red.ofdUrl }}</a>
        </el-descriptions-item>
        <el-descriptions-item label="XML地址">
          <a :href="invoice.red.xmlUrl" target="_blank">{{ invoice.red.xmlUrl }}</a>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'InvoiceDetail',
  props: {
    invoiceId: {
      type: [String, Number],
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    search_type : {
      type : String ,
      default : '',
    },
    search_params : {
      type : Object ,
      default : {},
    },
    disc_id : {
      type : [String , Number] ,
      default : 0 ,
    },
  },
  data() {
    return {
      loading: false,
      invoice: {
        invoiceNumber: '',
        invoiceType: '',
        invoiceDate: '',
        taxAmount: '',
        totalAmount: '',
        buyerTaxNumber: '',
        buyerName: '',
        buyerAddress: '',
        remark: '',
        ewmUrl: '',
        pdfUrl: '',
        ofdUrl: '',
        xmlUrl: '',
        red : {
          InvoiceNo : '',
          InvoiceDate : '',
          ewmUrl: '',
          pdfUrl: '',
          ofdUrl: '',
          xmlUrl: '',
          confirmStatus : '',
        },
      }
    };
  },
  watch: {
    invoiceId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchInvoiceData(newId);
        }
      }
    }
  },
  methods: {
    async fetchInvoiceData(id) {
      this.loading = true;

      try {
        let that = this;
        let params = {};
        if(this.search_type === 'tax_invoice'){
          // 税局发票查询
          params = Object.assign(params, this.search_params);
          params.search_type = this.search_type;
        }else{
          // ERP 发票查询
          params.id = id;
        }
        params.disc_id = this.disc_id ;
        // 转换为 url 参数
        let params_str = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        this.$myhttp.get(
          "admin/getInvoiceInfo?" + params_str,
            {"Content-Type": "application/json",}
          ).then((backdata) => {
            if (backdata.data.code == 200) {
              that.invoice = backdata.data.data;
            } else {
              this.$message.error(backdata.data.msg);
            }
        }).catch((err) => {
            this.$message.error(err);
          }).finally(() => {
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
      }
    },
    handleClose() {
      this.$emit('close', false);
    },
    applyIssue(){
      let that = this;
      this.$myhttp.post(
        "admin/cancelApplyIssue",
        {id : this.invoiceId , disc_id : this.disc_id},
        {"Content-Type": "application/json",}
      ).then((backdata) => {
        if (backdata.data.code == 200) {
          this.fetchInvoiceData(this.invoiceId);
        } else {
          this.$message.error(backdata.data.msg);
        }
      })
    }
  }
}
</script>

<style scoped>
.invoice-detail {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #333;
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/invoiceDetail.vue